<template>
    <div>
        <div class="pageback"></div>
        <div class="pagemain">
            <div class="container">
                <div class="row">
                    <div class="col-sm-2" v-if="webW">
                        <div id="JfLeftMenuOut">
                            <div :class="(fixedLeftmenu?'fixedMenuCls':'')"
                                 :style="fixedLeftmenu?('width:'+LeftMenuWidth+'px'):''" id="JfLeftMenu">
                                <AuthorLeft></AuthorLeft>
                            </div>
                            <div v-if="fixedLeftmenu" :style="'width:'+LeftMenuWidth+'px'"><br></div>
                        </div>


                    </div>
                    <div :class="(webW?'col-sm-7':'col-sm-12')">
                        <div style="overflow-x: hidden;">

                            <AuthorTop v-if="!webW"></AuthorTop>

                            <!-- <el-switch
                                    v-if="webW"
                                    @click="openAutoReflashFunc"
                                    :style="'position: absolute;z-index: 1;right:10px;margin-top:10px;'"
                                    active-text="下拉刷新"
                                    v-model="openAutoReflash"
                                    active-color="#13ce66"
                                    inactive-color="#dddddd">
                            </el-switch> -->

                            <el-tabs id="zhutiMain" v-model="type"  @tab-click="tabClick" style="background-color: #fff;padding-left: 10px;">
                                <!-- <el-tab-pane label="粉丝" name="fans"></el-tab-pane>
                                <el-tab-pane label="关注" name="att"></el-tab-pane> -->
                            </el-tabs>
                            <div class="baiseback">
                                <p class="typedesc  " v-if="lander.uid==authorId">提示：双击头像删除</p>
                                <div class="row" v-if="webW">
                                    <div class="col-sm-2 center" v-for="(t,i) in tableData" :key="i">
                                        <img    :src="type=='fans'?t.faceimg:t.tfaceimg" @dblclick="delhandle(t,i)"  class="touxiangfantt hander" >
                                        <p @click="goUHome(t.auid)" class="oneline hander">{{type=='fans'?t.uname:t.tuname}}</p>
                                    </div>
                                </div>

                                <el-row :gutter="20" v-if="!webW">
                                    <el-col :span="6"  v-for="(t,i) in tableData" :key="i">
                                        <div class="center">
                                            <img  :src="type=='fans'?t.faceimg:t.tfaceimg" @dblclick="delhandle(t,i)"  class="touxiangfantt hander" >
                                            <p  @click="goUHome(t.tuid)" class="oneline hander">{{type=='fans'?t.uname:t.tuname}}</p>
                                        </div>
                                    </el-col>

                                </el-row>


                                <div class="baiseback"  v-if="tableDataloading">
                                    <div class="center">
                                        <img src="../../../assets/img/loading.gif">
                                        <p class="typedesc">数据加载中....</p>
                                    </div>
                                </div>
                                <div class="baiseback" style="height: 100vh;"  v-if="!tableDataloading&&tableData.length==0">
                                    <div class="center">
                                        <img src="../../../assets/img/zwsj.png">
                                        <p class="typedesc">暂无数据</p>
                                    </div>
                                </div>


                                <div class="center" >
                                    <el-pagination 
                                            @current-change="handlePageChange"
                                            :current-page="query.pageNo"
                                            :page-size="query.pageSize"
                                            layout="total, prev, pager, next"
                                            :total="pageTotal">
                                    </el-pagination>


                                </div>

                                <p class="typedesc center" v-if="tableDataFinish">没有数据了</p>
                            </div>
                            <div class="baiseback">
                                <Footer></Footer>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-3" v-if="webW">
                        <div id="JfRightMenuOut">
                            <div :class="(fixedRightmenu?'fixedMenuRT':'')" :style="fixedRightmenu?('width:'+RightMenuWidth+'px'):''" id="JfRightMenu">
                                 <AuthorTop></AuthorTop>
                            </div>
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="h100"></div>
        <img src="../../../assets/img/top.png" @click="gotopFunc" v-if="scrolltop" class="gotop hander">
    </div>

</template>
<script>

    import {dealResult, getWindowWidth} from '../../../api/common'
    import {attfansmpage, delAttFansById} from '../../../api';
    import  PubSub from 'pubsub-js'

    import Footer from "../Footer";
    import AuthorTop from "./AuthorTop";
    import AuthorLeft from "./AuthorLeft";

    export default {
        name: 'Fans',
        components: {
            Footer,
            AuthorTop,
            AuthorLeft

        },

        data() {
            return {
                webW:true,

                openAutoReflash: true,
                scrolltop: false,

                nouse: false,//禁用
                //菜单固定
                fixedLeftmenu: false,
                LeftMenuWidth: 0,
                fixedRightmenu: false,
                RightMenuWidth: 0,




                openAutoReflash:true,
                scrolltop:false,

                nouse:false,//禁用




                lander: {},
                type:'fans',
                authorId:'',


                // 信息
                tableData: [],
                tableDataloading:true,
                tableDataFinish:false,//避免滚动条在最后一直请求

                query: {
                    tyepId: '',
                    pageNo: 1,
                    pageSize: 60,
                },
                pageTotal: 0,



            };
        },
        methods: {
            goUHome(uid){
               this.$router.push('Home?type=myforum&authorId='+uid)
            },
            gotopFunc() {
                if(document.documentElement!=undefined)document.documentElement.scrollTop=0;
                if(document.body!=undefined) document.body.scrollTop=0;
            },

            tabClick(tab, event) {

               this.query.pageNo=1;
               this.tableData=[];
                this.tableDataFinish=false;
               this.getAttFansPage();
            },


            openAutoReflashFunc(){
                if(this.openAutoReflash)this.tableDataFinish=false;
            },

            // 分页导航
            handlePageChange(val) {
                this.query.pageNo = val;
                this.tableData=[];
                this.getAttFansPage();

                this.tableDataFinish=false;

                let forumMain=document.getElementById('zhutiMain');
                let top=forumMain.offsetTop;
                document.documentElement.scrollTop=top;
                 document.body.scrollTop=top;

            },



            //获取帖子分页
            getAttFansPage() {
                this.tableDataloading=true;
                this.tableDataFinish=false;

                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;
                this.query.type=this.type;
                this.query.authorId=this.authorId;



                attfansmpage( this.query).then((res) => {
                    this.tableDataloading=false;
                    dealResult(res.data);


                    if (res.data.status == 1) {


                        let li= res.data.obj.list;
                        if(li.length==0){

                            this.tableDataFinish=true;

                            return ;
                        }



                        this.tableData=this.tableData.concat(li);
                        this.pageTotal = res.data.obj.total//该页总共多少条记录

                        if( this.openAutoReflash  ) {
                            if( res.data.obj.hasNextPage )this.query.pageNo=res.data.obj.nextPage;
                            else this.query.pageNo=this.query.pageNo+1;
                        }

                        this.fixedmenu();


                    }else {
                        this.tableDataFinish=true;
                        this.$message.error(res.data.msg)
                    }
                })
            },


            fixedmenu(){

                let JfLeftMenu = document.getElementById('JfLeftMenu');
                let JfRightMenu = document.getElementById('JfRightMenu');

                let that=this;
                window.onscroll = function () {

                    let t = document.documentElement.scrollTop || document.body.scrollTop;
                    let h = document.documentElement.scrollHeight  ;
                    let wh = document.documentElement.clientHeight  ;




                    if (that.webW) {
                        that.LeftMenuWidth = JfLeftMenu.offsetWidth;
                        that.RightMenuWidth = JfRightMenu.offsetWidth;
                        

                        //t+wh=h

                        //必须写到onscroll里，因为高度是会变化的
                        let leftHeight = JfLeftMenu.offsetHeight;
                        let leftTop = JfLeftMenu.offsetTop;
                        if (t > leftTop + leftHeight) {
                            that.fixedLeftmenu = true;
                        } else {
                            that.fixedLeftmenu = true;
                        }
                        let rightHeight = JfRightMenu.offsetHeight;
                        let rightTop = JfRightMenu.offsetTop;
                        if (t > rightTop + rightHeight + 50) {
                            that.fixedRightmenu = true;
                        } else {
                            that.fixedRightmenu = true;
                        }


                    }


                    //出现回到顶部按钮
                    if (t > wh) that.scrolltop = true;
                    else that.scrolltop = false;


                    //滚动条到底部加载数据
                    if(t+wh>=h-100 && that.openAutoReflash && !that.tableDataFinish){

                        if(!that.tableDataloading)that.getAttFansPage();
                    }



                }

            },
            delhandle(t,index){
                if(this.lander.uid!=this.authorId)return;
                    this.$confirm("确定删除  "+(this.type=='fans'?t.uname:t.tuname)+" ？ ", "提示", {
                        type: "warning",
                    }) .then(() => {
                        this.loading = this.$loading({
                            lock: true,
                            text: "请求中...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });
                        let o={ id:t.id,uid:this.lander.uid,token:this.lander.token}
                        delAttFansById( o).then((res) => {
                            this.loading.close();
                            dealResult(res.data);
                            if (res.data.status == 1) {
                                this.$message.success(res.data.msg)
                                this.tableData.splice(index,1);
                            } else{
                                this.$message.error(res.data.msg)
                            }
                        })
                    });


            }

        }, mounted() {
            this.webW=getWindowWidth()>=1000?true:false;
            this.lander = JSON.parse(this.$store.state.logininfo);


            //固定左右菜单
            this.fixedmenu();


            if(this.$route.query.type==undefined||this.$route.query.authorId==undefined){
                this.$message.info("参数异常")
            }else{
                this.type=this.$route.query.type;
                this.authorId = this.$route.query.authorId;

                this.query.pageNo=1;
                this.tableData=[];
                this.getAttFansPage()
            }




            PubSub.subscribe('changeAttFansData',(msg,index)=>{
                this.query.pageNo=1;
                this.tableData=[];
                this.getAttFansPage();
            });

        }, watch:{
            $route:function(value){


                if(value.query.authorId!=undefined&&(value.query.type=="fans"||value.query.type=="att")){
                    if(this.type!=value.query.type||this.authorId!=value.query.authorId){


                            this.authorId=value.query.authorId;
                            this.type=value.query.type;

                            this.query.pageNo=1;
                            this.tableData=[];
                            this.getAttFansPage()


                    }
                }




            }
        },
        activated() {



            //固定左右菜单
            this.fixedmenu();



        },
        deactivated() {

        }

    };
</script>
<style scoped>

</style>
